import { AudienceTimeSinceMembershipAcquisitionTargetingAttributeFragment } from '@occc/graphql';

import { audienceFormInitialValues } from '../../../AudienceCreatePage/AudienceFormInitialValues';

export const getMembershipCreatedInitialValues = (
  membershipCreated: AudienceTimeSinceMembershipAcquisitionTargetingAttributeFragment | undefined,
) => {
  if (!membershipCreated) {
    return audienceFormInitialValues['membershipCreated'];
  }

  const { membershipCreatedAmount, membershipCreatedOperator } = membershipCreated;

  return {
    operator: membershipCreatedOperator,
    amount: membershipCreatedAmount,
  };
};
